/**
 * @author Madhu.Sudhan
 * @Date: 2023-04-29 13:05:06
 * @Last Modified by: ankit
 * @Last Modified time: 2024-05-29 17:50:20
 */

import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { Card, Row, Col, Form, Breadcrumb, Slider, Divider, Button, Switch, Input, Modal, message } from 'antd';
import { Link } from 'react-router-dom';
import { AppWrappperHOC } from '../Root/HOC';
import { constants, utils } from '../../devUtils';
import Container from '../../components/Container';
import { ZaggleCard, StyledYscFlipCards, StyledIdfcFlipCards } from '../NetworkCards/StyledNetworkCard';
import { StyledYscTransactionLimits, background, backgroundColour } from './StyledYscTransactionLimits';
import { YscTransactionLimitsPropTypes, YscTransactionLimitsMapDispatchToProps, YscTransactionLimitsMapStateToProps } from './YscTransactionLimitsDatahandler';
import { formatExpiryDate } from '../../devUtils/commonUtils';
import { CALCULATE_BALANCE_YSC } from '../NetworkCards/constants';
import { PER_DAY_LIMIT, PER_TRANSACTION_LIMIT, LIMIT_VALIDATION_MESSAGE } from './constants';
import { OtpScreen } from '../NetworkCards/OtpScreen';
import { FUND_TRANSFER_CONSTANTS } from '../FundTransfer/constants';

const { INDUSIND_MANAGE_CARD_USAGE } = FUND_TRANSFER_CONSTANTS;
class YscTransactionLimits extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      atm: 0,
      pos: 0,
      ecom: 0,
      nfc: 0,
      atm_per_txn: 0,
      pos_per_txn: 0,
      ecom_per_txn: 0,
      nfc_per_txn: 0,
      atm_enabled: true,
      pos_enabled: true,
      ecom_enabled: true,
      nfc_enabled: true,
      showResendText: false,
      remainingTime: 60,
      OTP: '',
      modalType: '',
    };
    this.statelesskeys = {
      defaultPayload: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSwitch = this.handleSwitch.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handleOTPChange = this.handleOTPChange.bind(this);
    this.handleResendOtp = this.handleResendOtp.bind(this);
  }

  componentDidMount() {
    const {
      match:
      { params:
        {
          id = '',
        } = {},
      } = {},
      onFetchCardDataYsc,
      onFetchYscTransactionLimit,
    } = this.props;
    onFetchCardDataYsc({ ysc_card_id: id });
    onFetchYscTransactionLimit({ ysc_card_id: id });
  }

  componentWillReceiveProps(nextProps) {
    const {
      match:
      { params:
        {
          id = '',
        } = {},
      } = {},
      fetchYscLimits,
      fetchYscLimits: {
        status,
        limits,
      } = {},
      updateYscLimits,
      updateYscLimits: {
        status: limit_status,
      } = {},
      onFetchYscTransactionLimit,
      GenerateOtpYsc,
      onSetYscLimitOtpSuccess,
      GenerateOtpYsc: {
        status: otp_status,
        message: otp_message = '',
      } = {},
    } = nextProps;
    const {
      fetchYscLimits: _fetchYscLimits,
      updateYscLimits: _updateYscLimits,
      GenerateOtpYsc: _GenerateOtpYsc,
    } = this.props;

    if (!utils.isEqual(GenerateOtpYsc, _GenerateOtpYsc) && otp_status) {
      this.setState({ modalType: 'OTP_SCREEN' });
      this.startTimer();
      onSetYscLimitOtpSuccess();
    } else if (otp_message === 'OTP already sent') {
      this.setState({ modalType: 'OTP_SCREEN' });
      this.startTimer();
      onSetYscLimitOtpSuccess();
    }
    if (!utils.isEqual(fetchYscLimits, _fetchYscLimits) && status && limits && limits.length === 4) {
      this.setState({
        atm: Number(limits[0].domestic.daily_txn),
        pos: Number(limits[1].domestic.daily_txn),
        ecom: Number(limits[2].domestic.daily_txn),
        nfc: Number(limits[3].domestic.daily_txn),
        atm_per_txn: Number(limits[0].domestic.per_txn),
        pos_per_txn: Number(limits[1].domestic.per_txn),
        ecom_per_txn: Number(limits[2].domestic.per_txn),
        nfc_per_txn: Number(limits[3].domestic.per_txn),
        atm_enabled: limits[0].domestic.is_enabled || false,
        pos_enabled: limits[1].domestic.is_enabled || false,
        ecom_enabled: limits[2].domestic.is_enabled || false,
        nfc_enabled: limits[3].domestic.is_enabled || false,
      });
      this.setState({ OTP: '', showResendText: false, remainingTime: 60, modalType: '' });
    } else if (!utils.isEqual(updateYscLimits, _updateYscLimits) && limit_status) {
      this.setState({ modalType: '', OTP: '', showResendText: false, remainingTime: 60 });
      clearInterval(this.timer);
      onFetchYscTransactionLimit({ ysc_card_id: id });
    }
  }

  componentWillUnmount() {
    const { onSetFetchTransactionLimits } = this.props;
    onSetFetchTransactionLimits();
  }

  setNewLimit(type) {
    const {
      atm,
      pos,
      ecom,
      nfc,
    } = this.state;
    switch (type) {
      case 'ATM Transactions':
        return atm;
      case 'POS Transactions':
        return pos;
      case 'ECOM Transactions':
        return ecom;
      case 'Contactless Transactions':
        return nfc;
      default:
        return 0;
    }
  }

  setNewLimitTxn(type) {
    const {
      atm_per_txn,
      pos_per_txn,
      ecom_per_txn,
      nfc_per_txn,
    } = this.state;
    switch (type) {
      case 'ATM Transactions':
        return atm_per_txn;
      case 'POS Transactions':
        return pos_per_txn;
      case 'ECOM Transactions':
        return ecom_per_txn;
      case 'Contactless Transactions':
        return nfc_per_txn;
      default:
        return 0;
    }
  }

  setInputValue(type, value) {
    switch (type) {
      case 'ATM Transactions':
        return this.setState({ atm: value });
      case 'POS Transactions':
        return this.setState({ pos: value });
      case 'ECOM Transactions':
        return this.setState({ ecom: value });
      case 'Contactless Transactions':
        return this.setState({ nfc: value });
      default:
        return 0;
    }
  }

  setInputValueTxn(type, value) {
    switch (type) {
      case 'ATM Transactions':
        return this.setState({ atm_per_txn: value });
      case 'POS Transactions':
        return this.setState({ pos_per_txn: value });
      case 'ECOM Transactions':
        return this.setState({ ecom_per_txn: value });
      case 'Contactless Transactions':
        return this.setState({ nfc_per_txn: value });
      default:
        return 0;
    }
  }

  sendOtp() {
    const {
      match:
      { params:
        {
          id: ysc_card_id = '',
        } = {},
      } = {},
      OnGenerateOtp,
    } = this.props;
    OnGenerateOtp({ ysc_card_id }, { otp_type: 'ysc_card_set_limit' });
  }

  handleResendOtp() {
    const {
      match:
      { params:
        {
          id: ysc_card_id = '',
        } = {},
      } = {},
      OnGenerateOtp,
    } = this.props;
    clearInterval(this.timer);
    OnGenerateOtp({ ysc_card_id }, { otp_type: 'ysc_card_set_limit' });
    this.setState({
      showResendText: false,
      remainingTime: 60,
    });
  }

  handleCheckLimits() {
    const {
      atm,
      pos,
      ecom,
      nfc,
      atm_per_txn,
      pos_per_txn,
      ecom_per_txn,
      nfc_per_txn,
      atm_enabled,
      pos_enabled,
      ecom_enabled,
      nfc_enabled,
    } = this.state;

    let type;


    switch (true) {
      case (atm_enabled && atm < atm_per_txn):
        type = 'ATM';
        break;
      case (pos_enabled && pos < pos_per_txn):
        type = 'POS';
        break;
      case (ecom_enabled && ecom < ecom_per_txn):
        type = 'ECOM';
        break;
      case (nfc_enabled && nfc < nfc_per_txn):
        type = 'Contactless';
        break;
      default:
        break;
    }

    return (type ? message.error(`${type} ${LIMIT_VALIDATION_MESSAGE}`) : this.sendOtp());
  }

  handleSubmit() {
    const {
      atm,
      pos,
      ecom,
      nfc,
      atm_per_txn,
      pos_per_txn,
      ecom_per_txn,
      nfc_per_txn,
      atm_enabled,
      pos_enabled,
      ecom_enabled,
      nfc_enabled,
      OTP,
    } = this.state;

    if (!OTP || OTP.trim().length === 0) {
      message.error('Please enter OTP to proceed');
      return;
    }
    const { fetchYscLimits: {
      limits = [],
    } = {},
    match:
      { params:
        {
          id = '',
        } = {},
      } = {},
    onUpdateYscTransactionLimits,
    } = this.props;
    const setLimit = [];
    limits.forEach(({ channel, channel_name, domestic, international }, index) => {
      let is_enabled;
      let daily_txn;
      let per_txn;

      switch (index) {
        case 0:
          is_enabled = atm_enabled;
          daily_txn = atm;
          per_txn = atm_per_txn;
          break;
        case 1:
          is_enabled = pos_enabled;
          daily_txn = pos;
          per_txn = pos_per_txn;
          break;
        case 2:
          is_enabled = ecom_enabled;
          daily_txn = ecom;
          per_txn = ecom_per_txn;
          break;
        case 3:
          is_enabled = nfc_enabled;
          daily_txn = nfc;
          per_txn = nfc_per_txn;
          break;
        default:
          is_enabled = false;
          daily_txn = 0;
      }
      const ob = {
        channel,
        channel_name,
        domestic: {
          channel_blur: domestic.channel_blur,
          channel_show: domestic.channel_show,
          daily_txn,
          per_txn,
          end_date: domestic.end_date,
          icon: domestic.icon,
          is_enabled,
          max: domestic.max,
          min: domestic.min,
        },
        international: {
          channel_blur: international.channel_blur,
          channel_show: international.channel_show,
          daily_txn: international.daily_txn,
          end_date: international.end_date,
          icon: international.icon,
          is_enabled: international.is_enabled,
          max: international.max,
          min: international.min,
        },
      };
      setLimit.push(ob);
    });
    onUpdateYscTransactionLimits({ ysc_card_id: id, limits: setLimit, otp: OTP });
  }

  handleSwitch(type, value) {
    switch (type) {
      case 'ATM Transactions':
        this.setState({ atm_enabled: value });
        break;
      case 'POS Transactions':
        this.setState({ pos_enabled: value });
        break;
      case 'ECOM Transactions':
        this.setState({ ecom_enabled: value });
        break;
      case 'Contactless Transactions':
        this.setState({ nfc_enabled: value });
        break;
      default:
        break;
    }
  }

  handleChange(type, value) {
    switch (type) {
      case 'ATM Transactions':
        this.setState({ atm: value });
        break;
      case 'POS Transactions':
        this.setState({ pos: value });
        break;
      case 'ECOM Transactions':
        this.setState({ ecom: value });
        break;
      case 'Contactless Transactions':
        this.setState({ nfc: value });
        break;
      default:
        break;
    }
  }

  handleChangePerTxn(type, value) {
    switch (type) {
      case 'ATM Transactions':
        this.setState({ atm_per_txn: value });
        break;
      case 'POS Transactions':
        this.setState({ pos_per_txn: value });
        break;
      case 'ECOM Transactions':
        this.setState({ ecom_per_txn: value });
        break;
      case 'Contactless Transactions':
        this.setState({ nfc_per_txn: value });
        break;
      default:
        break;
    }
  }

  handleModal(type) {
    this.setState({
      modalType: typeof (type) === 'string' ? type : '', OTP: '', showResendText: false, remainingTime: 60,
    });
    clearInterval(this.timer);
  }

  handleOTPChange(OTP) {
    this.setState({ OTP });
  }

  startTimer() {
    this.timer = setInterval(() => {
      const { remainingTime } = this.state;
      if (remainingTime === 1) {
        clearInterval(this.timer);
        this.setState({ showResendText: true });
      }
      this.setState((prevState) => ({
        remainingTime: prevState.remainingTime - 1,
      }));
    }, 1000);
  }

  renderCvvPresentImage(CardDataYsc) {
    const {
      UserDetails: {
        id: user_id = '',
      } = {},
    } = this.props;
    const {
      card_info: {
        CVV = '',
        Expirydate = '',
        CardStatus = '',
        CardNumber = '',
        BankName = '',
        Network = '',
        ProductType = '',
      } = {},
    } = CardDataYsc;
    const cvv = (user_id && CVV && CVV.length) ? utils.getDecryptedData(CVV, user_id) : '';
    const cardnumber = (user_id && CardNumber && CardNumber.length) ? utils.getDecryptedData(CardNumber, user_id) : '';
    const showImage = (
      <Fragment>
        <input type="checkbox" id="CardClick" />
        <label className="card-containert" htmlFor="CardClick">
          <div className="card-flip">
            <div className="side default-user" >
              {BankName && BankName.toLowerCase() === 'indusind bank' ?
                <h1><strong>Rs. {CALCULATE_BALANCE_YSC(CardDataYsc)}</strong></h1> : ''}
              {BankName && BankName.toLowerCase() === 'indusind bank' ?
                <div className="footer">
                  <b>
                    <span>Card Number:</span> {cardnumber}<br />
                    <span>Expiry:</span> {formatExpiryDate(Expirydate)}<br />
                    <span>Card Status:</span> {CardStatus}<br />
                  </b>
                </div> :
                <b style={background}>
                  <h1 style={backgroundColour}><strong>Rs. {CALCULATE_BALANCE_YSC(CardDataYsc)}</strong></h1>
                  <span>Card Number:</span> {cardnumber}<br />
                  <span>Expiry:</span> {formatExpiryDate(Expirydate)}<br />
                  <span>Card Status:</span> {CardStatus}<br />
                </b>
              }
            </div>
            <div className="side back">
              {BankName && BankName.toLowerCase() === 'indusind bank' ?
                <h3>{cvv}</h3> : <h3 style={background}>{cvv}</h3>}
            </div>
          </div>
        </label>
      </Fragment>
    );
    return (
      <Col xs={24} sm={24} md={10} lg={10} xl={10}>
        {BankName && BankName.toLowerCase() === 'indusind bank' && (
          <StyledYscFlipCards
            network={Network}
            product={ProductType}
            bankName={BankName}
          >
            {showImage}
          </StyledYscFlipCards>
        )}
        {BankName && BankName.toLowerCase() === 'idfc first bank' && (
          <StyledIdfcFlipCards bankName={BankName}>
            {showImage}
          </StyledIdfcFlipCards>
        )}
      </Col>
    );
  }

  renderCvvBlankImage(CardDataYsc) {
    const {
      UserDetails: {
        id: user_id = '',
      } = {},
    } = this.props;
    const {
      card_info: {
        Expirydate = '',
        CardStatus = '',
        CardNumber = '',
        BankName = '',
        Network = '',
        ProductType = '',
      } = {},
    } = CardDataYsc;
    const cardnumber = (user_id && CardNumber && CardNumber.length) ? utils.getDecryptedData(CardNumber, user_id) : '';
    const showImage = (
      <div className="card-flip default">
        <div className="side default-user" >
          <h1><strong>Rs. {CALCULATE_BALANCE_YSC(CardDataYsc)}</strong></h1>
          {BankName && BankName.toLowerCase() === 'indusind bank' ?
            <div className="footer">
              <b>
                <span>Card Number:</span> {cardnumber}<br />
                <span>Expiry:</span> {formatExpiryDate(Expirydate)}<br />
                <span>Card Status:</span> {CardStatus}<br />
              </b>
            </div> :
            <b style={background}>
              <h1 style={backgroundColour}><strong>Rs. {CALCULATE_BALANCE_YSC(CardDataYsc)}</strong></h1>
              <span>Card Number:</span> {cardnumber}<br />
              <span>Expiry:</span> {formatExpiryDate(Expirydate)}<br />
              <span>Card Status:</span> {CardStatus}<br />
            </b>
          }
        </div>
      </div>
    );
    return (
      <Col xs={24} sm={24} md={10} lg={10} xl={10}>
        {BankName && BankName.toLowerCase() === 'indusind bank' && (
          <StyledYscFlipCards
            network={Network}
            product={ProductType}
            bankName={BankName}
          >
            {showImage}
          </StyledYscFlipCards>
        )}
        {BankName && BankName.toLowerCase() === 'idfc first bank' && (
          <StyledIdfcFlipCards bankName={BankName}>
            {showImage}
          </StyledIdfcFlipCards>
        )}
      </Col>
    );
  }

  renderCardImages(CardDataYsc) {
    const { card_info: { CVV = '' } = {} } = CardDataYsc;
    return CVV ? this.renderCvvPresentImage(CardDataYsc) : this.renderCvvBlankImage(CardDataYsc);
  }

  renderOtpScreen() {
    const {
      SelectUserDetails: {
        phone = '',
      } = {},
      isLoadingStatus = false,
    } = this.props;
    const {
      OTP,
      showResendText,
      remainingTime,
    } = this.state;
    return (
      <OtpScreen
        type={INDUSIND_MANAGE_CARD_USAGE}
        MobileNumber={phone}
        isLoadingStatus={isLoadingStatus}
        OTP={OTP}
        showResendText={showResendText}
        remainingTime={remainingTime}
        handleOTPChange={this.handleOTPChange}
        handleResendOtp={() => this.handleResendOtp()}
        verifyOTP={() => this.handleSubmit()}
      />
    );
  }

  renderModalUI(modalType) {
    switch (modalType) {
      case 'OTP_SCREEN':
        return this.renderOtpScreen();
      default:
        return '';
    }
  }

  renderSetLimits(name, limitValue, limitValuePerTxn, enabled, index) {
    const {
      fetchYscLimits:
      {
        limits = [],
      } = {},
    } = this.props;

    return (
      <Fragment>
        { limits && limits.length ?
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="padding-b-1">
            <Card className="rounded margin-b-1" hoverable>
              <h3 className="nomargin">{name}</h3>
              <Row align="middle" type="flex" gutter={[15, 10]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Col xs={10} sm={10} md={10} lg={10} xl={10}>
                    <div className="font-12">Current Limit</div>
                    <div className="font-12">{limits[index].domestic.daily_txn || 0}</div>
                  </Col>
                  <Col xs={10} sm={10} md={10} lg={10} xl={10}>
                    <div className="font-12">New Limit</div>
                    <Input
                      className="width-5"
                      type="text"
                      placeholder="Enter"
                      value={this.setNewLimit(name)}
                      onChange={({ target: { value = '' } }) => this.setInputValue(name, value)}
                      maxLength={limits[index].domestic.max.toString().length}
                      disabled={!enabled}
                    >
                    </Input>
                  </Col>
                  <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                    <Switch
                      className="custom-switch"
                      checked={enabled}
                      onChange={(value) => this.handleSwitch(name, value)}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <span className="font-12">{PER_DAY_LIMIT}</span>
                    <Slider
                      min={0}
                      max={limits[index].domestic.max || 0}
                      step={1}
                      className="custom-slider"
                      value={Number(limitValue) || 0}
                      onChange={(value) => this.handleChange(name, value)}
                      disabled={!enabled}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <div className="show-slider-values">
                      <span>0</span>
                      <span>{limits[index].domestic.max || 0}</span>
                    </div>
                  </Col>
                </Col>
              </Row>
              <Divider className="margin-t-2 margin-b-2" />
              <Row align="middle" type="flex" gutter={[15, 10]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Col xs={10} sm={10} md={10} lg={10} xl={10}>
                    <div className="font-12">Current Limit</div>
                    <div className="font-12">{limits[index].domestic.per_txn || 0}</div>
                  </Col>
                  <Col xs={10} sm={10} md={10} lg={10} xl={10}>
                    <div className="font-12">New Limit</div>
                    <Input
                      className="width-5"
                      type="text"
                      placeholder="Enter"
                      value={this.setNewLimitTxn(name)}
                      onChange={({ target: { value = '' } }) => this.setInputValueTxn(name, value)}
                      maxLength={limits[index].domestic.max.toString().length}
                      disabled={!enabled}
                    >
                    </Input>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <span className="font-12">{PER_TRANSACTION_LIMIT}</span>
                    <Slider
                      min={0}
                      max={limits[index].domestic.per_txn_max || 0}
                      step={1}
                      className="custom-slider"
                      value={Number(limitValuePerTxn) || 0}
                      onChange={(value) => this.handleChangePerTxn(name, value)}
                      disabled={!enabled}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <div className="show-slider-values">
                      <span>0</span>
                      <span>{limits[index].domestic.per_txn_max || 0}</span>
                    </div>
                  </Col>
                </Col>
              </Row>
            </Card>
          </Col>
          : '' }
      </Fragment>
    );
  }

  renderYscTransactionLimits() {
    const {
      atm,
      pos,
      ecom,
      nfc,
      atm_per_txn,
      pos_per_txn,
      ecom_per_txn,
      nfc_per_txn,
      atm_enabled,
      pos_enabled,
      ecom_enabled,
      nfc_enabled,
    } = this.state;
    const { fetchYscLimits:
      {
        limits = [],
      } = {},
    isTransactionLimitsLoading,
    history = {},
    } = this.props;
    return (
      <Fragment>
        { limits && limits.length ?
          <Col xs={24} sm={24} md={14} lg={14} xl={14}>
            <StyledYscTransactionLimits>
              {this.renderSetLimits('ATM Transactions', atm, atm_per_txn, atm_enabled, 0)}
              {this.renderSetLimits('POS Transactions', pos, pos_per_txn, pos_enabled, 1)}
              {this.renderSetLimits('ECOM Transactions', ecom, ecom_per_txn, ecom_enabled, 2)}
              {this.renderSetLimits('Contactless Transactions', nfc, nfc_per_txn, nfc_enabled, 3)}
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                <Button onClick={() => history.goBack()} className="white-btn margin-r-2 width-4">Cancel</Button>
                <Button
                  loading={isTransactionLimitsLoading}
                  className="ant-btn green-btn width-4"
                  onClick={() => this.handleCheckLimits()}
                >Send OTP
                </Button>
              </Col>
            </StyledYscTransactionLimits>
          </Col> : ''}
      </Fragment>
    );
  }

  render() {
    const {
      CardDataYsc = {},
    } = this.props;
    const { modalType } = this.state;
    return (
      <Fragment>
        <Modal
          visible={!!modalType}
          onCancel={this.handleModal}
          size="sm"
          classname="default-popup"
          footer={null}
          maskClosable={false}
        >
          {modalType && this.renderModalUI(modalType)}
        </Modal>
        <br clear="all" />
        <Container>
          <ZaggleCard>
            <Row align="middle" type="flex" gutter={24} className="margin-t-2">
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <h1>Manage Zaggle Cards</h1>
                <Breadcrumb separator="<" className="margin-b-2 font-12 custom-breadcrumb">
                  <Breadcrumb.Item><Link to={constants.LINK_MY_PROFILE}>My Account</Link></Breadcrumb.Item>
                  <Breadcrumb.Item><Link to={constants.LINK_PAY_BALANCE}>Manage cards</Link></Breadcrumb.Item>
                  <Breadcrumb.Item>Manage Card Usage</Breadcrumb.Item>
                </Breadcrumb>
              </Col>
            </Row>
            <Card className="rounded noborder noshadow">
              <Row align="top" type="flex" gutter={30}>
                {this.renderCardImages(CardDataYsc)}
                {this.renderYscTransactionLimits()}
              </Row>
            </Card>
          </ZaggleCard>
        </Container>
      </Fragment>
    );
  }
}

YscTransactionLimits.propTypes = YscTransactionLimitsPropTypes;

const YscTransactionLimitsWrapper = Form.create({ name: 'normal_admin' })(YscTransactionLimits);
const component = connect(YscTransactionLimitsMapStateToProps, YscTransactionLimitsMapDispatchToProps)(AppWrappperHOC(YscTransactionLimitsWrapper));
export { YscTransactionLimits, YscTransactionLimitsWrapper };
export default component;



// WEBPACK FOOTER //
// client/containers/YscTransactionLimits/index.js